import React from 'react';

const Footer = () => {
  return (
    <>
      <hr />
      <footer>
        <ul className="list-unstyled list-inline pull-right">
          <li><a href="https://github.com/GlobalQuran/site/issues">Feedback</a></li>
          <li><a href="https://github.com/GlobalQuran/site/issues">Report Bug</a></li>
          <li><a href="https://github.com/GlobalQuran/site/issues">Help</a></li>
          <li><a href="/about">About us</a></li>
          <li><a href="/contact">Contact us</a></li>
        </ul>
        <p>© <a href="https://globalquran.com/">GlobalQuran.com</a> 2025</p>
      </footer>
    </>
  );
};

export default Footer; 